/**
 * Strips single-line (//) and multi-line comments from a JSON string
 * so config files can use JSONC format.
 * Respects strings so URLs like "http://..." are not affected.
 */
function stripJsonComments(text) {
  let result = '';
  let i = 0;
  while (i < text.length) {
    // skip over strings
    if (text[i] === '"') {
      result += '"';
      i++;
      while (i < text.length && text[i] !== '"') {
        if (text[i] === '\\') {
          result += text[i++];
        }
        result += text[i++];
      }
      if (i < text.length) result += text[i++]; // closing quote
    }
    // single-line comment
    else if (text[i] === '/' && text[i + 1] === '/') {
      while (i < text.length && text[i] !== '\n') i++;
    }
    // multi-line comment
    else if (text[i] === '/' && text[i + 1] === '*') {
      i += 2;
      while (i < text.length && !(text[i] === '*' && text[i + 1] === '/')) i++;
      i += 2;
    } else {
      result += text[i++];
    }
  }
  return result;
}

/**
 * Fetches the app configuration.
 * Tries /config.local.json first (untracked, developer-specific, supports JSONC comments),
 * falls back to /config.json if the local file doesn't exist.
 */
export async function fetchConfig() {
  try {
    const localResponse = await fetch('/config.local.json');
    if (localResponse.ok) {
      const text = await localResponse.text();
      return JSON.parse(stripJsonComments(text));
    }
  } catch {
    // local config not available, fall back
  }

  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error(`Failed to fetch config: ${response.status}`);
  }
  return await response.json();
}
